import React from 'react';
import { observer } from 'mobx-react-lite';

import { HookFormDropdown } from '@components/ReactHookFormFields/HookFormDropdown';
import { apartmentStore } from '@stores/apartmentStore';

/** Dropdown value for the "other" option, which isn't an apartment ID */
export const OTHER_APARTMENT_OPTION = 'other';

/** Dropdown of the other apartments in the selected apartment's real estate */
export const ApartmentsInRealEstateDropdown = observer(
  ({
    name,
    label,
    otherOptionLabel,
  }: {
    name: string;
    label: string;
    /** If given, an "other" option is added as the last item */
    otherOptionLabel?: string;
  }) => (
    <HookFormDropdown
      name={name}
      label={{ value: label, type: 'static' }}
      placeholder=""
      items={[
        ...(apartmentStore.selectedApartment?.realestate.apartmentDetails ?? [])
          .map(({ number, apartmentId }) => ({
            label: number,
            value: apartmentId,
          }))
          .sort((a, b) =>
            a.label.localeCompare(b.label, undefined, { numeric: true })
          ),
        ...(otherOptionLabel
          ? [{ label: otherOptionLabel, value: OTHER_APARTMENT_OPTION }]
          : []),
      ]}
    />
  )
);
